<div nz-row nzType="flex">
    <div nz-col nzSpan="6">
        <div class="formname">{{formTitle}}</div>
    </div>

    <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end;">
        <form nz-form [nzLayout]="'inline'">
            <nz-form-item>
                <nz-radio-group name="radioValue" [(ngModel)]="radioValue"
                    (ngModelChange)="changeRadioButton($event,true)" nzButtonStyle="solid">
                    <label nz-radio-button nzValue="A">Today's</label>
                    <label nz-radio-button nzValue="B">Yesterday's</label>
                    <label nz-radio-button nzValue="C">Last 7 Days</label>
                    <label nz-radio-button nzValue="D">Last Month</label>
                    <label nz-radio-button nzValue="E">Current Month</label>
                </nz-radio-group>
            </nz-form-item>

            <nz-form-item>
                <button nz-button nzType="primary" style="margin-right: 0px;" (click)="fireEvent()"
                    [nzLoading]="loadprojectexcel"><i nz-icon nzType="file-excel" nzTheme="outline"></i></button>
            </nz-form-item>

            <nz-form-item style="margin-right: 0px;">
                <button nz-button [nzType]="isFilterApplied" (click)="showFilter()"><i nz-icon
                        nzType="filter"></i></button>
            </nz-form-item>

            <!-- <nz-form-item>
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" autocomplete="off" nz-input placeholder="Search by User"
                        [(ngModel)]="searchText" (keydown.enter)="onEnterGetAllEmployeeWiseHoursDetails()" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button name="button1" id="button1" nzType="primary"
                        (click)="getAllEmployeeWiseHoursDetails(true)" nzSearch><i nz-icon nzType="search"></i></button>
                </ng-template>
            </nz-form-item> -->
        </form>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">
        <div class="filter {{filterClass}}">
            <div class="filter-box">
                <form nz-form>
                    <div nz-row nzGutter="16">
                        <div nz-col nzSpan="7">
                            <div nz-row>
                                <div nz-col nzSpan="24">
                                    <nz-form-label nzNoColon><b>Date</b></nz-form-label>

                                    <nz-input-group>
                                        <div nz-row>
                                            <div nz-col nzSpan="12">
                                                <nz-date-picker style="width: 100%;" nzFormat="dd/MM/yyyy"
                                                    name="startDate" (nzOnOpenChange)="startDateHandle($event)"
                                                    [(ngModel)]="START_DATE">
                                                </nz-date-picker>
                                            </div>

                                            <div nz-col nzSpan="12">
                                                <nz-date-picker #endDatePicker style="width: 100%;"
                                                    nzFormat="dd/MM/yyyy" name="endDate"
                                                    [nzDisabledDate]="disabledEndDate" [(ngModel)]="END_DATE">
                                                </nz-date-picker>
                                            </div>
                                        </div>
                                    </nz-input-group>
                                </div>

                                <!-- <div nz-col nzSpan="24">
                                    <nz-form-label nzNoColon><b>Actions</b></nz-form-label>

                                    <nz-input-group>
                                        <nz-radio-group name="radioValue" [(ngModel)]="radioValue"
                                            (ngModelChange)="changeRadioButton($event,false)" nzButtonStyle="solid">
                                            <label nz-radio-button nzValue="A">Today's</label>
                                            <label nz-radio-button nzValue="B">Yesterday's</label>
                                            <label nz-radio-button nzValue="C">Last 7 Days</label>
                                            <label nz-radio-button nzValue="D">Last Month</label>
                                            <label nz-radio-button nzValue="E">Current Month</label>
                                        </nz-radio-group>
                                    </nz-input-group>
                                </div> -->
                            </div>
                        </div>

                        <div nz-col nzSpan="17">
                            <nz-form-label nzNoColon><b>Users</b></nz-form-label>

                            <nz-input-group>
                                <nz-select style="width: 100%;" name="moduleAssigneeName" nzMaxTagCount="5"
                                    nzMode="multiple" nzShowSearch nzAllowClear [(ngModel)]="MODULE_ASSIGNEE_ID"
                                    nzPlaceHolder="Select Users">
                                    <nz-option nzCustomContent *ngFor="let assignee of newAssigneeList"
                                        [nzValue]="assignee.USER_ID" [nzLabel]="assignee.USER_NAME">
                                        <div>
                                            {{assignee.USER_NAME }} {{MODULE_ASSIGNEE_ID}}
                                        </div>

                                        <div style="font-size: 12px; color: gray; text-align: right;">
                                            <span>~&nbsp;{{assignee.TASK_CATEGORY_NAME}}</span>
                                        </div>
                                    </nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="7">
                            <!-- <nz-form-label nzNoColon><b>Project Type</b></nz-form-label>

                            <nz-input-group>
                                <nz-select style="width: 100%;" name="type" nzShowSearch nzAllowClear
                                    (ngModelChange)="onStatusChange($event)" nzPlaceHolder="Select Project Type"
                                    [(ngModel)]="TYPE">
                                    <nz-option nzLabel="Billable" nzValue="B"></nz-option>
                                    <nz-option nzLabel="Non Billable" nzValue="NB"></nz-option>
                                </nz-select>
                            </nz-input-group> -->
                        </div>

                        <div nz-col nzSpan="17">
                            <nz-form-label nzNoColon><b>Project</b></nz-form-label>

                            <nz-input-group>
                                <nz-select name="projectName" style="width: 100%;" nzMode="multiple" nzMaxTagCount="5"
                                    nzShowSearch nzAllowClear style="width: 100%" [(ngModel)]="projectID"
                                    nzPlaceHolder="Select Project">
                                    <nz-option *ngFor="let project of projectList" [nzValue]="project.ID"
                                        [nzLabel]="project.NAME"></nz-option>
                                </nz-select>
                            </nz-input-group>
                        </div>

                        <div nz-col nzSpan="24">
                            <nz-form-label nzNoColon><b>Actions</b></nz-form-label><br />

                            <nz-button-group nzSize="default">
                                <button style="margin-right: 10px;" nz-button nzType="primary"
                                    (click)="getAllEmployeeWiseHoursDetails(true)" nzJustify="end">
                                    <i nz-icon nzType="filter"></i>Apply Filter
                                </button>
                                <button nz-button nzType="primary" (click)="clearFilter()">
                                    <i nz-icon nzType="delete"></i>Clear Filter
                                </button>
                            </nz-button-group>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div nz-row>
    <div nz-col nzSpan="24">

        <nz-table #table nzBordered [nzData]="employeeData" [nzLoading]="loadingRecords" [nzFrontPagination]="false"
            nzSize="small" [nzScroll]="scroll">
            <thead>
                <tr>
                    <th nzLeft style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="160px">
                        <b style="font-size:12px !important">Employee Name</b>
                    </th>
                    <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="100px">
                        <b style="font-size:12px !important">Rate</b>
                    </th>
                    <th *ngFor="let project of maxColumns"
                        style="text-align: center; white-space: pre-line; padding: 2px;" [colSpan]="2">
                        <b style=" font-size:12px !important ;white-space: pre-line; overflow: hidden; text-overflow: ellipsis; text-align: left;"
                            nz-tooltip
                            [nzTooltipTitle]="employeeData[0]?.P[project - 1]?.PROJECT_NAME || 'No Project Name'">
                            {{
                            (employeeData[0]?.P[project - 1]?.PROJECT_NAME?.length > 15
                            ? employeeData[0]?.P[project - 1]?.PROJECT_NAME.slice(0, 15) + '...'
                            : employeeData[0]?.P[project - 1]?.PROJECT_NAME) || 'Project' + project
                            }}
                        </b>
                    </th>
                    <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="140px" nzRight>
                        <b style="font-size:12px !important">Total Amount</b>
                    </th>
                    <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="140px" nzRight>
                        <b style="font-size:12px !important">Total Hours</b>
                    </th>
                    <th style="text-align: center; padding: 2px;  " [rowSpan]="2" nzWidth="140px" nzRight>
                        <b style="font-size:12px !important">Total Days</b>
                    </th>

                </tr>
                <tr>
                    <ng-container *ngFor="let project of maxColumns">
                        <th style="text-align: center; padding: 2px;  ">
                            <b style="font-size:12px !important">TIME</b>
                        </th>
                        <th style="text-align: center; padding: 2px;  ">
                            <b style="font-size:12px !important">AMOUNT</b>
                        </th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let employee of employeeData; let last = last" [ngClass]="{ 'totals-row': last }">
                    <!-- Tooltip for EMP_NAME -->
                    <td nzLeft style="white-space: pre-line; text-align: left; padding: 2px;" nz-tooltip
                        [nzTooltipTitle]="employee.EMP_NAME  ">
                        {{ employee.EMP_NAME?.length > 5 ? employee.EMP_NAME.slice(0, 30) : employee.EMP_NAME }}
                    </td>

                    <td nz-tooltip [nzTooltipTitle]="employee.RATE_PER_HOUR | number: '1.2-2'"
                        style="white-space: pre-line; text-align: right; padding: 2px;">
                        {{ employee.RATE_PER_HOUR | number: '1.2-2' }}
                    </td>

                    <ng-container *ngFor="let projectIndex of maxColumns">
                        <td style="white-space: nowrap; text-align: center; overflow: hidden; text-overflow: ellipsis; padding: 2px;"
                            nz-tooltip [nzTooltipTitle]="employee.P[projectIndex - 1]?.TIME">
                            {{
                            (employee.P[projectIndex - 1]?.TIME?.length > 5
                            ? employee.P[projectIndex - 1]?.TIME.slice(0, 8)
                            : employee.P[projectIndex - 1]?.TIME)
                            }}
                        </td>
                        <td style="white-space: nowrap; text-align: right; overflow: hidden; text-overflow: ellipsis; padding: 2px;"
                            nz-tooltip [nzTooltipTitle]="employee.P[projectIndex - 1]?.AMOUNT | number: '1.2-2'">
                            <!-- <label for="">{{projectIndex}} {{}}</label> -->
                            {{
                            employee.P[projectIndex - 1]?.AMOUNT != null
                            ? (employee.P[projectIndex - 1]?.AMOUNT | number: '1.2-2')
                            : '-'
                            }}
                        </td>

                    </ng-container>

                    <!-- Tooltip for TOTAL_AMOUNT -->
                    <td style="white-space: pre-line; text-align: right; padding: 2px;" nzRight nz-tooltip
                        [nzTooltipTitle]="employee.TOTAL_AMOUNT?.toString().length > 10 ? employee.TOTAL_AMOUNT : employee.TOTAL_AMOUNT">
                        {{ employee.TOTAL_AMOUNT?.toString().length > 10 ? employee.TOTAL_AMOUNT.toString().slice(0, 10)
                        : employee.TOTAL_AMOUNT | number: '1.2-2' }}
                    </td>

                    <!-- Tooltip for TOTAL_HOURS -->
                    <td style="white-space: pre-line; text-align: center; padding: 2px;" nzRight nz-tooltip
                        [nzTooltipTitle]="employee.TOTAL_HOURS?.length > 10 ? employee.TOTAL_HOURS : employee.TOTAL_HOURS ">
                        {{ employee.TOTAL_HOURS?.length > 10 ? employee.TOTAL_HOURS.slice(0, 10) : employee.TOTAL_HOURS
                        }}
                    </td>

                    <!-- Tooltip for TOTAL_DAYS -->
                    <td style="white-space: pre-line; text-align: center; padding: 2px;" nzRight nz-tooltip
                        [nzTooltipTitle]="employee.TOTAL_DAYS?.toString().length > 10 ? employee.TOTAL_DAYS : employee.TOTAL_DAYS">
                        <label for=""> {{TOTAL_DAYS}}</label>
                        {{ employee.TOTAL_DAYS?.toString().length > 10 ? employee.TOTAL_DAYS.toString().slice(0, 10) :
                        employee.TOTAL_DAYS }}
                    </td>
                </tr>
            </tbody>

        </nz-table>




    </div>
</div>